export default {
  cardStyle: {
    borderRadius: "12px",
    background: "#FFFFFF",
    positon: "relative",
    boxShadow: "0px 10px 10px rgba(38, 38, 38, 0.05)",
    borderRadius: "12px",
    padding: "20px",
    minWidth: "160px",
    alignItems: "center",
  },
  greenBorder: {
    border: "1px solid #83CFA4",
    boxShadow: "1px 1px 1px 1px #83CFA4",
  },
  checkBoxIcon: {
    position: "absolute",
    top: "15px",
    right: "15px"
  },
  cancelIcon: {
    position: "absolute",
    top: "5px",
    right: "15px"
  }
};
